import React, {useEffect, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderTopSection from "../../components/partials/HeaderTop";
import Footer from "../../components/partials/Footer";
import LoadingSpinner from "../../utils/LoadingSpinner";

const Menage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        // Simuler le chargement des ressources
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    // Vérifier si l'utilisateur est connecté
    const isUserLoggedIn = () => {
        // Vérifier la présence d'un token ou d'infos utilisateur dans le localStorage/sessionStorage
        const token = localStorage.getItem('token') || sessionStorage.getItem('token');
        const user = localStorage.getItem('user') || sessionStorage.getItem('user');
        return !!(token || user);
    };

    // Gérer la redirection après clic sur un bouton
    const handleProfessionalRedirect = () => {
        if (isUserLoggedIn()) {
            navigate('/professional-candidate');
        } else {
            navigate('/professionals');
        }
    };

    return (
        <>

            {/* Affichage du spinner de chargement */}
            <LoadingSpinner
                isVisible={isLoading}
                loadingText="Chargement de la page..."
            />

            <HeaderTopSection/>

            <main className="main overflow-hidden">

                {/* Hero Section */}
                <section className="hero-section bg-gradient-primary py-xxl-25 py-20 position-relative overflow-hidden">
                    <div className="container position-relative z-1">
                        <div className="row align-items-center justify-content-lg-between justify-content-center">
                            <div className="col-xxl-6 col-xl-5 col-lg-5 col-md-8">
                                <div className="hero-content text-lg-start text-center">
                                    <div className="section-title">
                                        <div className="badge-section mb-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="800">
                                            <span className="badge bg-white text-primary fw-700 fs-15 px-4 py-2 rounded-pill shadow-sm">
                                                🧹 SERVICES DE MÉNAGE
                                            </span>
                                        </div>
                                        <h1 className="text-white fw-800 mb-xxl-6 mb-xl-5 mb-4 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1000">
                                            Contact rapide, candidats éprouvés<br/>
                                            <span className="text-warning">le nettoyage à portée de main</span>
                                        </h1>
                                        <p className="text-light fs-20 mb-5 aos-init aos-animate" data-aos="fade-up" data-aos-duration="1200">
                                            Des professionnels du nettoyage vérifiés pour un intérieur impeccable sans effort
                                        </p>
                                        <div className="hero-features aos-init aos-animate" data-aos="fade-up" data-aos-duration="1400">
                                            <div className="d-flex flex-wrap gap-3 justify-content-lg-start justify-content-center">
                                                <div className="feature-tag bg-white bg-opacity-25 text-white px-4 py-2 rounded-pill fs-15 fw-600">
                                                    ✅ Profils vérifiés
                                                </div>
                                                <div className="feature-tag bg-white bg-opacity-25 text-white px-4 py-2 rounded-pill fs-15 fw-600">
                                                    ⚡ Réponse rapide
                                                </div>
                                                <div className="feature-tag bg-white bg-opacity-25 text-white px-4 py-2 rounded-pill fs-15 fw-600">
                                                    💰 Prix transparents
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xxl-6 col-xl-5 col-lg-5">
                                <div className="hero-image position-relative aos-init aos-animate"
                                     data-aos="zoom-in" data-aos-duration="1500">
                                    <div className="floating-elements">
                                        <div className="floating-card card1 bg-white shadow-lg rounded-4 p-4 position-absolute">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon-circle bg-primary text-white rounded-circle d-flex align-items-center justify-content-center">
                                                    ⭐
                                                </div>
                                                <div>
                                                    <h6 className="fw-700 mb-1">4.7/5</h6>
                                                    <small className="text-muted fs-14">Satisfaction clients</small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="floating-card card2 bg-white shadow-lg rounded-4 p-4 position-absolute">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon-circle bg-success text-white rounded-circle d-flex align-items-center justify-content-center">
                                                    👥
                                                </div>
                                                <div>
                                                    <h6 className="fw-700 mb-1">5000+</h6>
                                                    <small className="text-muted fs-14">Professionnels</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <img src="assets/images/service/menage/hero-menage.jpg"
                                         alt="Professionnelle du ménage"
                                         className="img-fluid rounded-4 shadow-lg"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wave-bg"></div>
                </section>

                {/* Section Processus */}
                <section className="process-section py-xxl-25 py-20 bg-light">
                    <div className="container">
                        <div className="row justify-content-center mb-xxl-15 mb-xl-10 mb-8">
                            <div className="col-lg-8 text-center">
                                <div className="">
                                    <h2 className="fw-800 text-dark mb-4 fs-32">
                                        Trouvez votre professionnel en 3 étapes
                                    </h2>
                                </div>
                                <p className="text-muted fs-20">
                                    Un processus simple et transparent pour un nettoyage sans souci
                                </p>
                            </div>
                        </div>
                        <div className="row g-4 justify-content-center">
                            <div className="col-lg-4 col-md-6">
                                <div className="process-card card border-0 shadow-sm h-100 text-center p-5 rounded-4 aos-init aos-animate"
                                     data-aos="fade-up" data-aos-duration="800">
                                    <div className="process-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto fw-800">
                                        1
                                    </div>
                                    <h5 className="fw-700 mb-3 fs-18">Choisissez votre service</h5>
                                    <p className="text-muted fs-16">
                                        Sélectionnez le type de nettoyage dont vous avez besoin et votre localisation
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="process-card card border-0 shadow-sm h-100 text-center p-5 rounded-4 aos-init aos-animate"
                                     data-aos="fade-up" data-aos-duration="1000">
                                    <div className="process-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto fw-800">
                                        2
                                    </div>
                                    <h5 className="fw-700 mb-3 fs-18">Comparez les profils</h5>
                                    <p className="text-muted fs-16">
                                        Consultez les avis, expériences et tarifs des professionnels près de chez vous
                                    </p>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="process-card card border-0 shadow-sm h-100 text-center p-5 rounded-4 aos-init aos-animate"
                                     data-aos="fade-up" data-aos-duration="1200">
                                    <div className="process-number bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center mb-4 mx-auto fw-800">
                                        3
                                    </div>
                                    <h5 className="fw-700 mb-3 fs-18">Contactez directement</h5>
                                    <p className="text-muted fs-16">
                                        Échangez avec le professionnel et planifiez l'intervention en toute confiance
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-6">
                            <div className="col-lg-8 text-center">
                                <div className="bg-white rounded-4 p-4 shadow-sm">
                                    <p className="text-primary fw-600 fs-16 mb-0">
                                        💡 <strong>Notre avantage :</strong> Pas d'intermédiaire - vous contactez directement les professionnels vérifiés
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Section Services */}
                <section className="services-section py-xxl-25 py-20">
                    <div className="container">
                        <div className="row justify-content-center mb-xxl-15 mb-xl-10 mb-8">
                            <div className="col-lg-8 text-center">
                                <div className="">
                                    <h2 className="fw-800 text-dark mb-4 fs-32">
                                        Nos services de nettoyage
                                    </h2>
                                    <p className="text-muted fs-20">
                                        Des solutions adaptées à tous vos besoins d'entretien
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Service 1 - Nettoyage général */}
                        <section className="service-card card border-0 shadow-lg mb-6 rounded-4 overflow-hidden">
                            <div className="container p-12">
                                <div className="row g-6 align-items-md-center justify-content-between">
                                    <div className="col-lg-5 col-md-6 col-sm-6">
                                        <div className="quick-thumb w-100 overflow-hidden aos-init aos-animate"
                                             data-aos="zoom-in-right" data-aos-duration="1500"
                                             style={{borderRadius: '10%'}}>
                                            <img
                                                src="assets/images/service/menage/nettoyage-general.jpg"
                                                alt="Nettoyage de maison et bureau" className="w-100"/>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-6">
                                        <div className="quick-content">
                                            <div className="service-icon bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4">
                                                🏠
                                            </div>
                                            <h3 className="fw-800 text-dark mb-4 fs-28">Nettoyage maison & bureau</h3>

                                            <p className="text-muted fs-16 mb-4">
                                                Vous avez du désordre ? Vous n'avez pas le temps de vous occuper du nettoyage ?
                                                Plus besoin de demander à vos amis. Sur Driven Home Services, trouvez le professionnel qu'il vous faut en quelques clics.
                                            </p>

                                            <div className="mb-4">
                                                <h6 className="fw-700 text-dark mb-3 fs-17">Nous intervenons pour :</h6>
                                                <ul className="text-muted fs-16">
                                                    <li className="mb-2">• <strong>Appartements et maisons</strong> - nettoyage complet</li>
                                                    <li className="mb-2">• <strong>Bureaux</strong> - en dehors des heures de travail</li>
                                                    <li className="mb-2">• <strong>Après rénovation</strong> - nettoyage de fin de chantier</li>
                                                    <li className="mb-2">• <strong>Vitres et surfaces</strong> - résultat impeccable garanti</li>
                                                </ul>
                                            </div>

                                            <p className="text-muted fs-16 mb-4">
                                                Oubliez les agences. Ici, vous choisissez vous-même la personne directement à partir du profil.
                                                Un simple message suffit pour que quelqu'un passe demain à l'heure qui vous convient.
                                            </p>

                                            <ul className="service-features list-unstyled mb-4">
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Sans engagement d'agence</span>
                                                </li>
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Contact direct avec le professionnel</span>
                                                </li>
                                                <li className="d-flex align-items-center gap-3 mb-3">
                                                    <span className="text-success fs-18">✅</span>
                                                    <span className="fs-16">Intervention rapide</span>
                                                </li>
                                            </ul>

                                            <button
                                                onClick={handleProfessionalRedirect}
                                                className="btn btn-primary fw-600 px-5 py-3 rounded-pill fs-16">
                                                Trouver un nettoyeur
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Service 2 - Aide ménagère complète */}
                        <div className="service-card card border-0 shadow-lg mb-6 rounded-4 overflow-hidden">
                            <div className="row g-0 align-items-center flex-lg-row-reverse">
                                <div className="col-lg-6 pb-12">
                                    <div className="p-xxl-8 p-xl-6 p-5">
                                        <div className="service-icon bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4">
                                            ✨
                                        </div>
                                        <h3 className="fw-800 text-dark mb-4 fs-28">Aide ménagère complète</h3>

                                        <p className="text-muted fs-16 mb-4">
                                            Lessive, repassage, vaisselle, courses, garde-robe, réfrigérateur, salle de bains.
                                            La liste est interminable. Et tout est « pour demain ».
                                        </p>

                                        <div className="mb-4">
                                            <h6 className="fw-700 text-dark mb-3 fs-17">Services inclus :</h6>
                                            <ul className="text-muted fs-16">
                                                <li className="mb-2">• <strong>Entretien complet</strong> - ménage, rangement, organisation</li>
                                                <li className="mb-2">• <strong>Linge</strong> - lessive, repassage, pliage</li>
                                                <li className="mb-2">• <strong>Courses</strong> - achats et gestion des provisions</li>
                                                <li className="mb-2">• <strong>Entretien spécifique</strong> - frigo, salle de bain, cuisines</li>
                                            </ul>
                                        </div>

                                        <p className="text-muted fs-16 mb-4">
                                            Vous avez des enfants et vous ne savez pas quand faire les courses ?
                                            Vous dirigez une entreprise et ne voulez pas penser à passer l'aspirateur ?
                                            Retrouvez du temps pour vous en confiant ces tâches à nos professionnels.
                                        </p>

                                        <ul className="service-features list-unstyled mb-4">
                                            <li className="d-flex align-items-center gap-3 mb-3">
                                                <span className="text-success fs-18">✓</span>
                                                <span className="fs-16">Horaires flexibles</span>
                                            </li>
                                            <li className="d-flex align-items-center gap-3 mb-3">
                                                <span className="text-success fs-18">✓</span>
                                                <span className="fs-16">Services modulables</span>
                                            </li>
                                            <li className="d-flex align-items-center gap-3 mb-3">
                                                <span className="text-success fs-18">✓</span>
                                                <span className="fs-16">Expérience et références</span>
                                            </li>
                                        </ul>
                                        <button
                                            onClick={handleProfessionalRedirect}
                                            className="btn btn-warning text-white fw-600 px-5 py-3 rounded-pill fs-16">
                                            Voir les aides ménagères
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <img
                                        src="assets/images/service/menage/aide-menagere.jpg"
                                        alt="Aide ménagère complète"
                                        className="img-fluid h-100 object-fit-cover"/>
                                </div>
                            </div>
                        </div>

                        {/* Service 3 - Nettoyage spécialisé */}
                        <section className="service-card card border-0 shadow-lg rounded-4 overflow-hidden">
                            <div className="container">
                                <div className="row g-6 align-items-md-center justify-content-between">
                                    <div className="col-lg-6 col-md-6 col-sm-6 p-12">
                                        <div className="quick-content">
                                            <div className="service-icon bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-4">
                                                ✨
                                            </div>
                                            <h3 className="fw-800 text-dark mb-4 fs-28">Nettoyage spécialisé</h3>

                                            <p className="text-muted fs-16 mb-4">
                                                Parfois, il s'agit d'aider à nettoyer la salle de bains ou de donner un coup de main
                                                après des travaux de rénovation. Ou au bureau, où la poussière s'accumule plus vite que les courriels.
                                            </p>

                                            <div className="mb-4">
                                                <h6 className="fw-700 text-dark mb-3 fs-17">Situations spécifiques :</h6>
                                                <p className="text-muted fs-16 mb-3">
                                                    <strong>« J'avais l'habitude de m'occuper de tout moi-même - après le travail.
                                                        Et puis il s'est avéré qu'il suffisait d'un message pour que quelqu'un passe demain à 17 heures. »</strong>
                                                </p>
                                            </div>

                                            <div className="mb-4">
                                                <h6 className="fw-700 text-dark mb-3 fs-17">Nos interventions spécialisées :</h6>
                                                <ul className="text-muted fs-16">
                                                    <li className="mb-2">• <strong>Nettoyage après travaux</strong> - poussière, résidus</li>
                                                    <li className="mb-2">• <strong>Locaux commerciaux</strong> - boutiques, restaurants</li>
                                                    <li className="mb-2">• <strong>Nettoyage de vitres</strong> - intérieur et extérieur</li>
                                                    <li className="mb-2">• <strong>Entretien ponctuel</strong> - pour événements spéciaux</li>
                                                </ul>
                                            </div>

                                            <p className="text-muted fs-16 mb-4">
                                                Vous avez trop de travail et vous ne voulez pas faire le ménage vous-même ?
                                                Nettoyer les vitres vous semble être une punition ?
                                                Chez Driven Home Services, c'est vous qui décidez quoi, où et quand.
                                            </p>

                                            <button
                                                onClick={handleProfessionalRedirect}
                                                className="btn btn-success fw-600 px-5 py-3 rounded-pill fs-16">
                                                Consulter les spécialistes
                                            </button>
                                        </div>
                                    </div>
                                    <div className="col-lg-5 col-md-6 col-sm-6">
                                        <div className="quick-thumb w-100 overflow-hidden aos-init aos-animate"
                                             data-aos="zoom-in-right" data-aos-duration="1500"
                                             style={{borderRadius: '10%'}}>
                                            <img src="assets/images/service/menage/nettoyage-specialise.jpg"
                                                 alt="Nettoyage spécialisé"
                                                 className="w-100"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </section>

                {/* Section CTA */}
                <section className="cta-section bg-primary py-xxl-25 py-20">
                    <div className="container">
                        <div className="row justify-content-center text-center">
                            <div className="col-lg-8">
                                <h2 className="text-white fw-800 mb-4 fs-32">
                                    Libérez-vous des corvées de ménage
                                </h2>
                                <p className="text-light mb-5 fs-20">
                                    Des professionnels de confiance pour un intérieur impeccable
                                </p>
                                <div className="d-flex flex-wrap gap-4 justify-content-center">
                                    <button
                                        onClick={handleProfessionalRedirect}
                                        className="btn btn-success fw-600 px-5 py-3 rounded-pill fs-16">
                                        Trouver un professionnel
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </main>

            <Footer/>

            <style jsx>{`
                .bg-gradient-primary {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                }

                .wave-bg {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    width: 100%;
                    height: 100px;
                    background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1200 120' preserveAspectRatio='none'%3E%3Cpath d='M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z' fill='white'%3E%3C/path%3E%3C/svg%3E");
                    background-size: cover;
                    background-position: center;
                }

                .hero-image {
                    position: relative;
                }

                .floating-card {
                    z-index: 2;
                }

                .card1 {
                    top: 20px;
                    left: -20px;
                    animation: float 3s ease-in-out infinite;
                }

                .card2 {
                    bottom: 20px;
                    right: -20px;
                    animation: float 3s ease-in-out infinite 1.5s;
                }

                .icon-circle {
                    width: 40px;
                    height: 40px;
                    font-size: 18px;
                }

                .process-number {
                    width: 60px;
                    height: 60px;
                    font-size: 24px;
                    font-weight: bold;
                }

                .service-icon {
                    width: 80px;
                    height: 80px;
                    font-size: 32px;
                }

                @keyframes float {
                    0%, 100% { transform: translateY(0); }
                    50% { transform: translateY(-10px); }
                }

                .service-card img {
                    transition: transform 0.3s ease;
                }

                .service-card:hover img {
                    transform: scale(1.05);
                }

                .btn {
                    transition: all 0.3s ease;
                }

                .btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
                }

                /* Améliorations typographiques */
                .fs-14 { font-size: 14px; }
                .fs-15 { font-size: 15px; }
                .fs-16 { font-size: 16px; }
                .fs-17 { font-size: 17px; }
                .fs-18 { font-size: 18px; }
                .fs-20 { font-size: 20px; }
                .fs-28 { font-size: 28px; }
                .fs-32 { font-size: 32px; }

                .fw-600 { font-weight: 600; }
                .fw-700 { font-weight: 700; }
                .fw-800 { font-weight: 800; }
            `}</style>
        </>
    );
};

export default Menage;